import { useState } from 'react';
import { Button, Col, Drawer, Layout, Row } from 'antd';
import type { CSSProperties } from 'react';
import { Link } from 'react-router';

import { MenuUnfoldOutlined } from '@ant-design/icons';

import { LOGO } from '../../constants';
import { useCapturePostHog } from '../../hooks/useCapturePostHog';
import { SideNavMenu } from './sidemenu';

const HeaderLogo = ({ style }: { style: CSSProperties }) => (
  <Link to="/page/home">
    <img src={LOGO.src} alt={LOGO.alt} style={style} />
  </Link>
);

export const HeaderComponent = () => {
  const [visible, setVisible] = useState(false);
  const { capturePostHogCustomEvent } = useCapturePostHog();

  return (
    <Layout.Header className="headerComponent">
      <Row justify="end">
        <Col flex="auto">
          <HeaderLogo style={{ width: 'auto', height: 31, padding: 2, marginTop: 15, marginLeft: 20 }} />
        </Col>

        <Col>
          <Button
            type="text"
            className="menuTriggerMobile"
            aria-label="Open menu"
            icon={<MenuUnfoldOutlined />}
            onClick={() => {
              setVisible(true);
              capturePostHogCustomEvent('MobileDrawer visible');
            }}
          />
        </Col>
      </Row>
      <Drawer
        title={<HeaderLogo style={{ width: 'auto', height: 28, marginTop: 5 }} />}
        placement="left"
        closable={true}
        className="mobileDrawer"
        open={visible}
        onClose={() => {
          setVisible(false);
          capturePostHogCustomEvent('MobileDrawer hidden');
        }}
      >
        <div>
          <SideNavMenu />
        </div>
      </Drawer>
    </Layout.Header>
  );
};
